import { createReducer } from 'reduxsauce';
// import { createSelector } from 'reselect';
import Immutable from 'seamless-immutable';
import { DeclarationTypes } from '../actions/DeclarationActions';
import { ApplicationTypes } from '../actions/ApplicationActions';
// import { isEmpty } from '../../services/Validation';

/* ------------- Initial VisaDetails State ------------- */
export const INITIAL_STATE = Immutable({
  declared: false,
  readTerms: false,
});

/* ------------- Reducers ------------- */
export const onDeclared = (state, { declared }) => state.merge({ declared });
export const onRead = (state, { read }) => state.merge({ readTerms: read });
export const onClearCurrent = (state) =>
  state.merge({ declared: false, readTerms: false });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [DeclarationTypes.DECLARED]: onDeclared,
  [DeclarationTypes.READ_TERMS]: onRead,
  [ApplicationTypes.CLEAR_CURRENT_APPLICATION]: onClearCurrent,
});

/* ------------- Selectors ------------- */
export const hasDeclared = (state) => state.declaration.declared;
export const hasReadTerms = (state) => state.declaration.readTerms;



// WEBPACK FOOTER //
// ./src/state/reducers/DeclarationReducer.js